(function ($) {
	class W4D_ServiceForm {
		constructor() {
			this.initSelectors();
			this.bindEvents();
		}

		initSelectors() {
			this.$form = $('#serviceRequestForm');
			this.$submitBtn = this.$form.find('button[type="submit"]');
		}

		bindEvents() {
			W4D_FrontendHelper.startButtonCountdownUntilEnabled(this.$submitBtn, 9);

			this.$form.validate({
				submitHandler: (form) => {
					if (!W4D_FrontendHelper.checkHoneypot(this.$form)) {
						return;
					}

					this.handleSubmit(form);
				},
			});
		}

		handleSubmit(form) {
			const fd = new FormData(form);

			fd.append('action', 'w4d_handle_service_form_submit');
			fd.append('nonce', w4d_frontend_ajax.nonce);

			$.ajax({
				url: w4d_frontend_ajax.ajax_url,
				data: fd,
				method: 'POST',
				processData: false,
				contentType: false,
				success: (response) => {
					if (response.success) {
						this.$form.empty().html(response.data.success_html);
						W4D_Toast.showToast('success', response.data.message);
						this.$form[0].reset();
					} else {
						const errorMessage = response && response.data ? response.data.message : 'Došlo je do pogreške.';
						W4D_Toast.showToast('error', errorMessage);
					}
				},
				error: () => {
					W4D_Toast.showToast('error', 'Došlo je do pogreške. Pokušajte ponovno.');
				},
			});
		}
	}

	$(document).ready(function () {
		new W4D_ServiceForm();
	});
})(jQuery);
